import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IconSelectionDialogComponent } from './icon-selection-dialog/icon-selection-dialog.component';
import { IbexIconList } from '@ibexfusion/ibex-icon';

@Component({
    selector: 'icon-selector',
    templateUrl: './icon-selector.component.html',
    styleUrls: ['./icon-selector.component.scss'],
    standalone: false
})
export class IconSelectorComponent {

  iconList = [];

  @Input() key: string;
  @Input() model: Models.IbexBaseModel;
  @Input() type = 'new';
  @Input() variant = 'default';
  @Output() onChange = new EventEmitter<any>();
  @Output() modelChange = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {
  }

  change(event) {
    if (event.target && event.target.value) {
      this.onChange.emit(event.target.value);
    }
  }

  openSelector() {
    let list: any =  new IbexIconList();
    this.iconList = list.getList();
    let dialogRef: MatDialogRef<IconSelectionDialogComponent>;
    const config: MatDialogConfig = {
      data: {
        icons: this.iconList,
        type: this.type,
        active: this.model[this.key]
      }
    };

    dialogRef = this.dialog.open(IconSelectionDialogComponent, config);

    return dialogRef.afterClosed().toPromise().then(result => {
      if (result) {
        this.model[this.key] = result;
      }
    });
  }
}
